import React from "react";
import { AdyenPaymentAdvancedFlow } from "@components";

const AdyenPayment = ({
  paymentParameters,
  stripeAccountId,
  processingUrl,
  onError,
  externalSubmitRef,
  onAmountChange,
  setLoading,
  onCardTypeChange,
  onAmexChange,
  onCardBrandChange,
  onCardNotAllowed,
  onStorePaymentDetails,
  setProcessing,
  disablePayment,
  setBinLookupPending,
}) => {
  return (
    <AdyenPaymentAdvancedFlow
      paymentParameters={paymentParameters}
      stripeAccountId={stripeAccountId}
      externalSubmitRef={externalSubmitRef}
      processingUrl={processingUrl}
      onError={onError}
      onAmountChange={onAmountChange}
      setLoading={setLoading}
      onCardTypeChange={onCardTypeChange}
      onAmexChange={onAmexChange}
      onCardBrandChange={onCardBrandChange}
      onCardNotAllowed={onCardNotAllowed}
      onStorePaymentDetails={onStorePaymentDetails}
      disablePayment={disablePayment}
      setProcessing={setProcessing}
      setBinLookupPending={setBinLookupPending}
    />
  );
};

export { AdyenPayment };
